import apiFetch from '../apiFetch'

export default function (value) {
  return apiFetch({endPoint: `Recta/deleteRecta?idRecta=` + value, method: 'GET', body: null})
}